import React from "react";

/**
 * Чекбокс DS (canon-session 2026-07-24): кастомный бокс, checked = accent
 * заливка + галочка.
 */
export function Checkbox({
  checked = false,
  onChange,
  label,
  disabled = false,
}: {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: React.ReactNode;
  disabled?: boolean;
}) {
  return (
    <label
      className={`inline-flex items-center gap-2.5 text-sm text-text-primary ${
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
      }`}
    >
      <span
        onClick={() => !disabled && onChange?.(!checked)}
        className={`w-5 h-5 rounded-md inline-flex items-center justify-center border transition-colors ${
          checked ? "bg-accent border-accent" : "bg-transparent border-border"
        }`}
      >
        {checked && (
          <svg
            width={12}
            height={12}
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            strokeWidth={3}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
        )}
      </span>
      {label}
    </label>
  );
}
